import { css } from '@emotion/css';

const DESKTOP_BREAKPOINT = '1014px';

export const listStyles = {
  row: css({
    display: 'grid',
    gridTemplateColumns: 'auto auto minmax(0, 1fr) auto',
    gridTemplateAreas: `
      "date separator type points"
      "description description description points"
    `,
    columnGap: '16px',
    rowGap: '8px',
    padding: '20px 0',
    borderTop: '1px solid var(--color-border-default)',
    alignItems: 'start',
    '&:first-child': {
      borderTop: 'none',
    },
    [`@media (min-width: ${DESKTOP_BREAKPOINT})`]: {
      gridTemplateColumns: '132px 188px minmax(0, 1fr) auto',
      gridTemplateAreas: '"date type description points"',
      columnGap: '32px',
      rowGap: '0',
      alignItems: 'center',
      padding: '24px 0',
    },
  }),
  date: css({
    gridArea: 'date',
    whiteSpace: 'nowrap',
  }),
  type: css({
    gridArea: 'type',
    color: 'var(--color-text-secondary)',
    whiteSpace: 'nowrap',
  }),
  separator: css({
    gridArea: 'separator',
    color: 'var(--color-text-secondary)',
    [`@media (min-width: ${DESKTOP_BREAKPOINT})`]: {
      display: 'none',
    },
  }),
  description: css({
    gridArea: 'description',
    minWidth: 0,
    overflowWrap: 'anywhere',
  }),
  points: css({
    gridArea: 'points',
    justifySelf: 'end',
    whiteSpace: 'nowrap',
  }),
};

export const pageStyles = {
  link: {
    textDecoration: 'none',
    color: 'inherit',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:visited, &:hover, &:active': {
      textDecoration: 'none',
      color: 'inherit',
    },
    '& span': {
      color: 'inherit',
    },
  },
  container: {
    border: '1px solid var(--color-border-default)',
    borderRadius: 'var(--size-800) var(--size-800) var(--size-400) var(--size-400)',
  },
  header: {
    borderBottom: '1px solid var(--color-border-default)',
  },
};
